module.exports = __webpack_public_path__ + "static/media/hamburguesa.6e43e511.svg";